import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fail",
  "use": "icon-fail-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-fail\">\r\n  <title>fail</title>\r\n  <g>\r\n    <path d=\"M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,14a6,6,0,1,1,6-6A6,6,0,0,1,8,14Z\" />\r\n    <polygon points=\"10.12 4.46 8 6.59 5.88 4.46 4.46 5.88 6.59 8 4.46 10.12 5.88 11.54 8 9.41 10.12 11.54 11.54 10.12 9.41 8 11.54 5.88 10.12 4.46\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/fail.svg
// module id = 284
// module chunks = 0 1